import React from "react";
import Footer1 from "./Footer1";
import Footer2 from "./Footer2";
import Footer3 from "./Footer3";
import Footer4 from "./Footer4";
import Footer5 from "./Footer5";

export default function HomeFooter() {
  return (
    <div>
      <Footer1 />
      <Footer2 />
    </div>
  );
}
